import { DatabaseRecordType, EnumHelper } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";

export interface IModifiedRecordListItem {
    id: string;
    companyId: string;
    title: string;
    userCode: string;
    userName: string;
    userPicture: string;
    modifyDate: number;
    fileType: number;
    recordType: number;

    getRecordTypeImageClass(): string;
    getRecordTypeIntraUrl(): string;
    getRecordTypeTitle(): string;
    isFile(): boolean;
}

export class ModifiedRecordListItem implements IModifiedRecordListItem {
    id: string;
    companyId: string;
    title: string;
    userCode: string;
    userName: string;
    userPicture: string;
    modifyDate: number;
    fileType: number;
    recordType: number;

    constructor();
    constructor(obj: IModifiedRecordListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.title = obj && obj.title || "";
        this.userCode = obj && obj.userCode || "";
        this.userName = obj && obj.userName || "";
        this.userPicture = obj && obj.userPicture || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.fileType = obj && obj.fileType || 0;
        this.recordType = obj && obj.recordType || 0;
    }

    getRecordTypeImageClass(): string {
        switch (this.recordType) {
        case DatabaseRecordType.Message:
            return "message";
        case DatabaseRecordType.Document:
            return "file_type_20";
        case DatabaseRecordType.File:
            return "file_type_" + this.fileType.toString(10);
        case DatabaseRecordType.Event:
            return "event";
        case DatabaseRecordType.Task:
            return "task";
        case DatabaseRecordType.RecordUser:
            return "record";
        case DatabaseRecordType.CompanyGroup:
            return "companyGroup";
        case DatabaseRecordType.Company:
            return "company";
        case DatabaseRecordType.UserGroup:
            return "userGroup";
        case DatabaseRecordType.User:
            return "user";
        case DatabaseRecordType.InstantMessage:
            return "instantMessage";
        default:
            return "";
        }
    }

    static getIntraUrlByRecordType(recordType: number): string {
        switch (recordType) {
        case DatabaseRecordType.Message:
            return "new/message";
        case DatabaseRecordType.Document:
            return "new/document";
        case DatabaseRecordType.File:
            return "new/document";
        case DatabaseRecordType.Event:
            return "new/event";
        case DatabaseRecordType.Task:
            return "new/task";
        case DatabaseRecordType.RecordUser:
            return "new/record";
        case DatabaseRecordType.CompanyGroup:
            return "companygroup";
        case DatabaseRecordType.Company:
            return "new/company";
        case DatabaseRecordType.UserGroup:
            return "new/usergroup";
        case DatabaseRecordType.User:
            return "new/user?companyId";
        case DatabaseRecordType.InstantMessage:
            return "new/instantmessage";
        case DatabaseRecordType.WhistleBlow:
            return "new/whistleblow";
        default:
            return "";
        }
    }

    getRecordTypeIntraUrl(): string {
        return ModifiedRecordListItem.getIntraUrlByRecordType(this.recordType);
    }

    static getTitleByRecordType(recordType: number): string {
        switch (recordType) {
        case DatabaseRecordType.Message:
            return Translations.Message;
        case DatabaseRecordType.Document:
            return Translations.EditableDocument;
        case DatabaseRecordType.File:
            return Translations.File;
        case DatabaseRecordType.Event:
            return Translations.Event;
        case DatabaseRecordType.Task:
            return Translations.Task;
        case DatabaseRecordType.RecordUser:
            return Translations.RecordUser;
        case DatabaseRecordType.CompanyGroup:
            return Translations.CompanyGroup;
        case DatabaseRecordType.Company:
            return Translations.Company;
        case DatabaseRecordType.UserGroup:
            return Translations.UserGroup;
        case DatabaseRecordType.User:
            return Translations.User;
        case DatabaseRecordType.InstantMessage:
            return Translations.InstantMessage;
        case DatabaseRecordType.WhistleBlow:
            return Translations.WhistleBlow;
        default:
            return "";
        }
    }

    getRecordTypeTitle(): string {
        return ModifiedRecordListItem.getTitleByRecordType(this.recordType);
    }

    static getPluralTitleByRecordType(recordType: number): string {
        switch (recordType) {
        case DatabaseRecordType.Message:
            return Translations.Messages;
        case DatabaseRecordType.Document:
            return Translations.Documents;
        case DatabaseRecordType.File:
            return Translations.Files;
        case DatabaseRecordType.Event:
            return Translations.Events;
        case DatabaseRecordType.Task:
            return Translations.Tasks;
        case DatabaseRecordType.RecordUser:
            return Translations.Resources;
        case DatabaseRecordType.CompanyGroup:
            return Translations.CompanyGroups;
        case DatabaseRecordType.Company:
            return Translations.Companies;
        case DatabaseRecordType.UserGroup:
            return Translations.UserGroups;
        case DatabaseRecordType.User:
            return Translations.Users;
        case DatabaseRecordType.InstantMessage:
            return Translations.InstantMessagesMenuTitle;
        case DatabaseRecordType.WhistleBlow:
            return Translations.WhistleBlow;
        default:
            return "";
        }
    }

    isFile(): boolean {
        return EnumHelper.isEqual(this.recordType, DatabaseRecordType.File);
    }
}